import React from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from '../../../app/common/sharedComponents/Modal';
import { ButtonLarge } from '../../../app/common/sharedComponents/buttons/ButtonLarge';
import { ButtonBlockColumn } from '../../../app/common/sharedStyledComponents/GenericStyles.styled';
import { Body4 } from '../../../app/common/typography';
import { AudioModalMessageContainer } from './styled.audioWebsiteOnlyModal';

interface AudioWebsiteOnlyModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function AudioWebsiteOnlyModal ({
  isOpen,
  onClose,
}: AudioWebsiteOnlyModalProps) {
  const { t } = useTranslation();

  return (
    <Modal isOpen={isOpen} handleModalClose={onClose}>
      <AudioModalMessageContainer>
        <Body4>
          {t('COMMON.ASSESSMENT.MODAL.AUDIO_FILES_ONLY_ACCESSIBLE_ON_WEBSITE')}
        </Body4>
      </AudioModalMessageContainer>
      <ButtonBlockColumn>
        <ButtonLarge
          title={t('COMMON.ASSESSMENT.MODAL.BUTTONS.OK')}
          onClick={onClose}
        />
      </ButtonBlockColumn>
    </Modal>
  );
}
